import React from 'react';

import { daysLabels, normalizedDaysLabels } from '../../app/date-helpers';

import Clock from '../../icons/Clock';
import { getDayOpeningHours } from './RestaurantDeliveryHours';
import QuestionCircle from "../../icons/QuestionCircle";
import { getOrdersConfig } from 'App/app/logic';

const RestaurantOrderingHours = props => {
  const { restaurant, todayHours, iconWrapperClass = '', showAllHours = false } = props;
  const label = daysLabels[(new Date()).getDay()];
  const orderingHours = getOrdersConfig(restaurant).deliveryHours;
  const content = `<div>${orderingHours.map((dayHours, index) => {
    return `${normalizedDaysLabels[index]}: ${getDayOpeningHours(dayHours)}`;
  }).join('</div><div>')}</div>`;
  return <div className="restaurant__opening-hours">
    <span className={iconWrapperClass}><Clock className="text-primary" /></span>
    <span className="capitalize ml-2">{label}</span>: {getDayOpeningHours(todayHours)}
    &nbsp;
    {
      showAllHours && <a tabIndex="0" role="button" className="btn btn-link restaurant__show-hours" data-toggle="popover" data-placement="bottom" data-trigger="focus" data-html="true" title={`Godziny przyjmowania zamówień ${restaurant.name}`} data-content={content}>
        <span className="md-plus"><QuestionCircle /></span>
        <span className="md-minus">inne dni</span>
      </a>
    }
  </div>;
};

RestaurantOrderingHours.displayName = 'RestaurantOrderingHours';

export default RestaurantOrderingHours;
